import { useEffect, useState } from 'react';
import { useShop } from '../app/boot.tsx';
import { useShopPaths } from '../app/nav.tsx';
import { message } from '../lib/errors.ts';
import { Banner, Button, Card, Loading, Page, useToast } from '../ui/index.tsx';

export function GroupLink() {
  const { api } = useShop();
  const { go } = useShopPaths();
  const toast = useToast();
  const [linked, setLinked] = useState<boolean | null>(null);
  const [code, setCode] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.staff.settings().then((a) => setLinked(a.staffGroupLinked)).catch(() => setLinked(false)); }, [api]);

  async function create() {
    setBusy(true);
    try {
      setCode((await api.staff.groupLinkCode()).code);
    } catch (e) {
      toast(message(e), 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Page title="กลุ่ม LINE แจ้งเตือนพนักงาน" back={() => go('/staff/manage')}>
      {linked === null ? <Loading /> : linked
        ? <Banner kind="success">เชื่อมกลุ่มแจ้งเตือนแล้ว ✓ ตั้งรหัสใหม่ได้หากต้องการเปลี่ยนกลุ่ม</Banner>
        : <Banner kind="warn">ยังไม่ได้เชื่อมกลุ่ม พนักงานจะไม่ได้รับแจ้งเตือนการจองใหม่</Banner>}
      <Card>
        <ol style={{ paddingLeft: 20, margin: 0 }} className="stack">
          <li>สร้างกลุ่ม LINE ของพนักงาน (หรือใช้กลุ่มเดิม)</li>
          <li>เชิญบัญชี LINE OA ของร้านเข้ากลุ่ม</li>
          <li>กดปุ่มด้านล่าง แล้วพิมพ์ข้อความที่ได้ลงในกลุ่ม</li>
        </ol>
      </Card>
      <div style={{ height: 12 }} />
      {code && (
        <>
          <div className="big-code">#เชื่อม {code}</div>
          <p className="muted small" style={{ margin: '8px 0 12px', textAlign: 'center' }}>รหัสใช้ได้ 24 ชั่วโมง</p>
        </>
      )}
      <Button block loading={busy} onClick={() => void create()}>{code ? 'สร้างรหัสใหม่' : 'สร้างรหัสเชื่อมกลุ่ม'}</Button>
    </Page>
  );
}
